var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileBlankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.980562 0C0.441253 0 0 0.441828 0 0.981839V14.7276C0 15.2676 0.441253 15.7094 0.980562 15.7094H10.7862C11.3255 15.7094 11.7667 15.2676 11.7667 14.7276V3.92736L7.84449 0H0.980562Z",
    fill: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82511 3.92736H11.7668L7.84454 0V2.94552C7.84454 3.48553 8.2858 3.92736 8.82511 3.92736Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBlankIcon);
export default __webpack_public_path__ + "static/media/fileBlankIcon.10eb72f90448ba59594979f7cb4aef46.svg";
export { ForwardRef as ReactComponent };